export enum AppHeaderStates {
  customer,merchant,customerLoggedIn, merchantLoggedIn
}
